export const METHOD_CARD = 'credit_card';
export const METHOD_INVOICE = 'invoice';
export const METHOD_PAYPAL = 'paypal';
export const METHOD_SEPA_DEBIT = 'sepa_debit';
